import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import {GetEarningRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
import moment from "moment";

const Earning = () => {

    const fetchReducer = useSelector((state) => state.FetchDataReducer)
 
    const dispatch = useDispatch()
     console.log("Dashboard",fetchReducer)

     useEffect(()=>{
        dispatch(GetEarningRequest())
     },[])

  return (
    <>
    <AfterLoginTopbar
    title={`Welcome ${fetchReducer.profileResponse?.data?.first_name}`}
    acttion="menu"
    />
     <Loader visible={fetchReducer.isloading} />
    <div className='comon-body'>
        <div className='balance-d mb-3'>
         
                <div className='balance-d-card'>
                <div className='balance-d-icon'>
                    <img src='images/Icon-2.png'/>
                </div>
                <div className='balance-d-info'>
                  <h5>Current Balance</h5>
                  <h4>$ {fetchReducer?.GetEarningResponse?.data?.total_earning}</h4>
                </div>
              
                </div>
           
        </div>
        <h3 className='page-title'>History</h3>
        {fetchReducer?.GetEarningResponse?.data?.earnings&&fetchReducer?.GetEarningResponse?.data?.earnings.length > 0 ?       
        
        <div className='earning-view'>

        <ul>
            {fetchReducer?.GetEarningResponse?.data?.earnings&&fetchReducer?.GetEarningResponse?.data?.earnings.map((earning, i)=>{
                return (
                    <li key={i}>
                <div className='history-card'>
                    {/* <div className='history-card-icon'>
                    <i class="fa-solid fa-tag"></i>
                    </div> */}
                    <div className='history-card-info'>
                        <h5>{earning?.text}</h5>
                        <span>{moment(earning?.transaction_at).format('ll')}</span>
                    </div>
                    <div className='history-card-price'>
                      +  $ {earning?.amount}
                    </div>
                </div>
            </li>
                )
            })}
            
        </ul>
        </div>
        :
        <h5>No record found</h5>
}
    </div>
  </>
  )
}

export default Earning